// Central role classification helpers so the whole UI stays consistent.
// Two mutually-exclusive buckets:
//   • LISTING_ROLES  — professionals who list properties (broker, seller, builder). Get PartnerDash + Add Property.
//   • SERVICE_ROLES  — service professionals who sell a service (loan agent, advocate, architect, etc.).
//                      Get MyServicesDashboard + portfolio management. NEVER see "Add Property".
// Admin + buyers/users are handled separately.

export const LISTING_ROLES = ["broker", "seller", "builder"];

export const SERVICE_ROLES = [
    "loan_agent",
    "advocate",
    "architect",
    "interior_designer",
    "civil_engineer",
    "civil_contractor",
    "property_valuer",
    "renovation",
];

export const isListingRole = (role) => LISTING_ROLES.includes(role);
export const isServiceRole = (role) => SERVICE_ROLES.includes(role);
export const isAdmin = (role) => role === "admin";

// Where the user's dashboard shortcut should route.
export const dashboardHomeFor = (role) => {
    if (isServiceRole(role)) return "/my-services";
    return "/dashboard";
};

// The "Post / Sell" CTA on Navbar + BottomNav + MobileHero swaps meaning for service pros:
// they see "My Portfolio" instead of "Add Property".
export const primaryPostCtaFor = (user) => {
    if (!user) return { to: "/register?intent=sell", label: "Post Property", isPortfolio: false };
    if (isServiceRole(user.role)) return { to: "/my-portfolio", label: "My Portfolio", isPortfolio: true };
    return { to: "/add-property", label: "Post Property", isPortfolio: false };
};
